export const DATE_FORMAT = 'YYYY/MM/DD'

export const DATE_TIME_FORMAT = 'YYYY/MM/DD - HH:mm'
